export const updateBackground = () => ({
	type: "BACKGROUND_MODE",
});

export const updateAnimation = () => ({
	type: "ANIMATION_MODE",
});
